import { serviceApi } from 'Shared/network';
import type { GetViewupSnsAccountsByUserUuidOkDto } from 'viewup-api';

export type GetViewupSnsAccountsRes = GetViewupSnsAccountsByUserUuidOkDto;

export const getViewupSnsAccounts = async (): Promise<GetViewupSnsAccountsRes> => {
  const response =
    await serviceApi.v1SnsAccount.snsAccountControllerGetViewupSnsAccountsByUserUuid();

  return response.data;
};
